import { makeStyles } from "@mui/styles";

const useDropdownStyles = makeStyles((theme) => ({
    primary_filled: {
        backgroundColor: theme.palette.primary.main,
        color: "white!important",
        borderRadius: "10px",
        borderBottom: "0px",
        "&, &:before, &:after": {
            borderBottom: "0px!important",
        },
        "&:hover": {
            backgroundColor: theme.palette.primaryDark.main,
            borderBottom: "0px",
        },
        "&:focus": {
            backgroundColor: theme.palette.primaryDark.main,
            borderBottom: "0px",
        },
        "&:before": {
            borderBottom: "0px",
        },
    },
    primary_outlined: {
        backgroundColor: "transparent",
        borderColor: theme.palette.primary.main,
        borderRadius: "10px",
        borderBottom: "0px",
        "&, &:before, &:after": {
            borderBottom: "0px!important",
        },
        "&:hover": {
            backgroundColor: "transparent",
            borderBottom: "0px",
        },
        "&:focus": {
            backgroundColor: "transparent",
            borderBottom: "0px",
        },
        "&:before": {
            borderBottom: "0px",
        },
    },
    secondary_filled: {
        backgroundColor: theme.palette.secondary.main,
        color: "white!important",
        borderRadius: "10px",
        borderBottom: "0px",
        "&, &:before, &:after": {
            borderBottom: "0px!important",
        },
        "&:hover": {
            backgroundColor: theme.palette.secondaryDark.main,
            borderBottom: "0px",
        },
        "&:focus": {
            backgroundColor: theme.palette.secondaryDark.main,
            borderBottom: "0px",
        },
        "&:before": {
            borderBottom: "0px",
        },
    },
    secondary_outlined: {
        backgroundColor: "transparent",
        borderColor: theme.palette.greyDark.main,
        border: "1px solid",
        "&:hover": {
            backgroundColor: "transparent",
            borderColor: theme.palette.secondary.main
        },
        "&:focus": {
            backgroundColor: "transparent",
            borderColor: theme.palette.secondary.main
        },
    },
    third_filled: {
        backgroundColor: theme.palette.third.main,
        color: "white!important",
        borderRadius: "10px",
        borderBottom: "0px",
        "&, &:before, &:after": {
            borderBottom: "0px!important",
        },
        "&:hover": {
            backgroundColor: theme.palette.thirdDark.main,
            borderBottom: "0px",
        },
        "&:focus": {
            backgroundColor: theme.palette.thirdDark.main,
            borderBottom: "0px",
        },
        "&:before": {
            borderBottom: "0px",
        },
    },
    third_outlined: {
        backgroundColor: "transparent",
        borderColor: "third",
        borderRadius: "10px",
        borderBottom: "0px",
        "&, &:before, &:after": {
            borderBottom: "0px!important",
        },
        "&:hover": {
            backgroundColor: "transparent",
            borderBottom: "0px",
        },
        "&:focus": {
            backgroundColor: "transparent",
            borderBottom: "0px",
        },
        "&:before": {
            borderBottom: "0px",
        },
    },
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 0.5,
        maxHeight: '100px',
        overflowY: 'auto',
        padding: '4px',
    },
    chip: {
        margin: '2px',
    },
    selectedNote: {
        marginTop: '8px',
        fontSize: '0.875rem',
        color: theme.palette.text?.secondary || '#666',
    },
}));

export default useDropdownStyles;